__turbopack_export_value__({
  "body-logo-18": "callbackForm-module-scss-module__7zOytq__body-logo-18",
  "body-text-12": "callbackForm-module-scss-module__7zOytq__body-text-12",
  "body-text-14": "callbackForm-module-scss-module__7zOytq__body-text-14",
  "body-text-16": "callbackForm-module-scss-module__7zOytq__body-text-16",
  "body-text-18": "callbackForm-module-scss-module__7zOytq__body-text-18",
  "body-text-20": "callbackForm-module-scss-module__7zOytq__body-text-20",
  "body-text-24": "callbackForm-module-scss-module__7zOytq__body-text-24",
  "body-text-24-2": "callbackForm-module-scss-module__7zOytq__body-text-24-2",
  "body-text-heading-2": "callbackForm-module-scss-module__7zOytq__body-text-heading-2",
  "body-text-heading-3": "callbackForm-module-scss-module__7zOytq__body-text-heading-3",
  "body-text-medium-14": "callbackForm-module-scss-module__7zOytq__body-text-medium-14",
  "body-text-medium-16": "callbackForm-module-scss-module__7zOytq__body-text-medium-16",
  "body-text-medium-18": "callbackForm-module-scss-module__7zOytq__body-text-medium-18",
  "body-text-medium2-18": "callbackForm-module-scss-module__7zOytq__body-text-medium2-18",
  "body-text2-14": "callbackForm-module-scss-module__7zOytq__body-text2-14",
  "body-text2-16": "callbackForm-module-scss-module__7zOytq__body-text2-16",
  "button-primary-text": "callbackForm-module-scss-module__7zOytq__button-primary-text",
  "button-text": "callbackForm-module-scss-module__7zOytq__button-text",
  "button2-text": "callbackForm-module-scss-module__7zOytq__button2-text",
  "card-shadow": "callbackForm-module-scss-module__7zOytq__card-shadow",
  "effect-menu": "callbackForm-module-scss-module__7zOytq__effect-menu",
  "form": "callbackForm-module-scss-module__7zOytq__form",
  "form__checkbox": "callbackForm-module-scss-module__7zOytq__form__checkbox",
  "form__contact": "callbackForm-module-scss-module__7zOytq__form__contact",
  "form__contacts": "callbackForm-module-scss-module__7zOytq__form__contacts",
  "form__header": "callbackForm-module-scss-module__7zOytq__form__header",
  "form__hint": "callbackForm-module-scss-module__7zOytq__form__hint",
  "form__submitButton": "callbackForm-module-scss-module__7zOytq__form__submitButton",
  "form__title": "callbackForm-module-scss-module__7zOytq__form__title",
  "header-1": "callbackForm-module-scss-module__7zOytq__header-1",
  "inputsContainer": "callbackForm-module-scss-module__7zOytq__inputsContainer",
  "main-container": "callbackForm-module-scss-module__7zOytq__main-container",
  "main-footer-container": "callbackForm-module-scss-module__7zOytq__main-footer-container",
  "main-header-container": "callbackForm-module-scss-module__7zOytq__main-header-container",
  "txt-12-bold": "callbackForm-module-scss-module__7zOytq__txt-12-bold",
  "txt-14-bold": "callbackForm-module-scss-module__7zOytq__txt-14-bold",
  "txt-14-bold-caps": "callbackForm-module-scss-module__7zOytq__txt-14-bold-caps",
  "txt-14-med": "callbackForm-module-scss-module__7zOytq__txt-14-med",
  "txt-16-bold": "callbackForm-module-scss-module__7zOytq__txt-16-bold",
  "txt-16-med": "callbackForm-module-scss-module__7zOytq__txt-16-med",
  "txt-18-bold": "callbackForm-module-scss-module__7zOytq__txt-18-bold",
  "txt-18-medium": "callbackForm-module-scss-module__7zOytq__txt-18-medium",
  "txt-18-medium-24": "callbackForm-module-scss-module__7zOytq__txt-18-medium-24",
  "txt-24-semi": "callbackForm-module-scss-module__7zOytq__txt-24-semi",
});
